module.exports = function() {
  return new Worker(__webpack_public_path__ + "27aa4ea6a60bd5ac0095.worker.js");
};